import { useEffect, useState } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextArea,
  CustomTextField,
} from '../../../common';
import { getSupplyOrderApiErrorMessage } from '../utils/supplyOrdersUtils';
import { SUPPLY_ORDER_ACTION_TEXTS } from '../constants/supplyOrdersConstants';
import { guardDialogClose } from '../../utils/actionLockUtils';

const SupplyOrderActionDialog = ({
  open,
  onClose,
  title,
  description,
  confirmLabel = 'Confirmar',
  requireReason = false,
  requireEmail = false,
  onConfirm,
  isProcessing = false,
}) => {
  const [reason, setReason] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (open) {
      setReason('');
      setRecipientEmail('');
      setErrorMessage('');
    }
  }, [open]);

  const handleConfirm = async () => {
    if (requireReason && !reason.trim()) {
      setErrorMessage('El motivo es requerido.');
      return;
    }

    try {
      setErrorMessage('');
      await onConfirm({
        reason: reason.trim() || undefined,
        recipient_email: recipientEmail.trim() || undefined,
      });
      onClose();
    } catch (error) {
      setErrorMessage(getSupplyOrderApiErrorMessage(error));
    }
  };

  if (!open) return null;

  return (
    <DialogContainer
      open={open}
      onClose={guardDialogClose(isProcessing, onClose)}
      size="small"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

          {requireReason && (
            <CustomTextArea
              label={SUPPLY_ORDER_ACTION_TEXTS.reason}
              value={reason}
              onChange={(event) => setReason(event.target.value)}
              minRows={2}
              required
              disabled={isProcessing}
            />
          )}

          {requireEmail && (
            <CustomTextField
              label="Email del destinatario (opcional)"
              value={recipientEmail}
              onChange={(event) => setRecipientEmail(event.target.value)}
              type="email"
              fullWidth
              disabled={isProcessing}
            />
          )}
        </Box>
      </DialogBody>
      <DialogActions
        handleClose={onClose}
        handleSave={handleConfirm}
        saveLabel={confirmLabel}
        saveButtonProps={{ isLoading: isProcessing }}
      />
    </DialogContainer>
  );
};

export default SupplyOrderActionDialog;
